import { render, staticRenderFns } from "./addRescueFund.vue?vue&type=template&id=679acd94&lang=pug"
import script from "./addRescueFund.vue?vue&type=script&lang=js"
export * from "./addRescueFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports